<!-- loading data layout start -->
@if (loadingData) {
  <div class="loading-screen text-center vh-100 d-flex align-items-center justify-content-center">
    <div>
      <img class="dino-loading-img" src="/assets/images/quote_monster_crunching_animation.gif?v=2" />
      <h3>Loading data.</h3>
    </div>
  </div>
}
<!-- loading data layout end -->

<!-- after loading data layout start -->
@if (!loadingData) {
  <div class="d-flex flex-column justify-content-between vh-100 qm-internal-admin-portal">
    <nav-menu />
    @if (isDevMode) {
      <mat-card appearance="raised" class="py-4 text-center rounded-0 d-block bg-white">
        <h1 class="qm-text-warn qa-site-warning-header">NOTE: THIS IS QA SITE, FOR TESTING PURPOSES ONLY</h1>
        <a mat-button class="qm-text-button" href="https://qmadminportal.quotemonster.co.nz">
          Click here go to live Admin Portal
        </a>
      </mat-card>
    }
    <div class="mb-auto flex-grow-1">
      <router-outlet />
    </div>
    <footer class="footer p-5 qm-bg-darkGray">
      <div class="container">
        <h6 class="mb-0 text-white text-uppercase">Quotemonster Internal Admin Portal Site &nbsp;&nbsp; v.2.0.0</h6>
      </div>
    </footer>
  </div>
}
